export type MembersStatusFilterValue = 'all' | 'active' | 'expiring' | 'expired';

type Props = {
  value: MembersStatusFilterValue;
  onChange: (next: MembersStatusFilterValue) => void;
  totalCount?: number | null;
};

const formatCount = (value: number | null | undefined): string | null => {
  if (value == null) return null;
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(value);
};

const MembersStatusFilter = ({ value, onChange, totalCount }: Props) => {
  const items: Array<{ key: MembersStatusFilterValue; label: string; showCount?: boolean }> = [
    { key: 'all', label: 'All', showCount: true },
    { key: 'active', label: 'Active' },
    { key: 'expiring', label: 'Expiring' },
    { key: 'expired', label: 'Expired' },
  ];

  return (
    <div className="members-status-filter" role="tablist" aria-label="Status filter">
      {items.map((item) => {
        const isActive = item.key === value;
        const countLabel = item.showCount ? formatCount(totalCount) : null;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`members-status-filter__chip${isActive ? ' members-status-filter__chip--active' : ''}`}
            onClick={() => onChange(item.key)}
            data-testid={`members-status-${item.key}`}
          >
            {item.label}
            {countLabel ? (
              <span className="members-status-filter__count">{countLabel}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default MembersStatusFilter;
